import { createFileRoute } from '@tanstack/react-router'
import { HistoryReplayPanel } from '@/components/history/history-replay-panel'

export const Route = createFileRoute('/history/$conversationId')({
  component: HistoryReplayPanel,
})
